import React from 'react';
import { Card, Text } from '@perch-labs/shrike';
import { formatWithCommas } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { LineItems } from '../../../components/line-items';

const getCopy = copyFor('billing.statement.billBreakdown');

interface Props {
  statement: GetStatementPageDataQuery['statement'];
  utilityDisplayName: string;
}

export const BillBreakdown = ({ statement, utilityDisplayName }: Props) => {
  if (!statement) return null;
  const { lineItemsFormatted, total, kwh } = statement;

  return (
    <Card mobileVariant="flat" margin={{ bottom: '32px' }}>
      <Card.Content>
        <Text
          textStyle="heading700"
          tag="h2"
          margin={{ top: '24px', bottom: '40px' }}
        >
          {getCopy('title')}
        </Text>
        <LineItems
          includeTooltips={true}
          lineItemsFormatted={lineItemsFormatted}
          statementTotal={total}
          utilityName={utilityDisplayName}
        />
        {!!kwh?.total && (
          <Text
            textStyle="paragraph400"
            color="secondary"
            margin={{ top: '16px' }}
          >
            {getCopy('energyUsed', { kwh: formatWithCommas(kwh.total) })}
          </Text>
        )}
      </Card.Content>
    </Card>
  );
};
